<template>
  <div class="machines pad">

    <machines-list @selected="selected" :show-warnings="true" />

  </div>
</template>

<script>
import MachinesList from '@/components/MachinesList'
export default {
  name: 'Machines',
  components: {
    MachinesList
  },
  methods: {
    selected (machine) {
      this.$router.push(`/view-machine/${machine._id}`)
    }
  }
}
</script>

<style>

</style>
